"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
function I18n(I18nProvider) {
    var i18nextInstance = i18next_1.default.createInstance({
        nsSeparator: false,
    });
    var Provider = I18nProvider(i18nextInstance);
    return {
        i18nextInstance: i18nextInstance,
        initialize: Provider.initialize.bind(Provider),
        getCurrentLocale: Provider.getCurrentLocale,
        changeLocale: Provider.changeLocale,
        t: Provider.translate,
    };
}
exports.default = I18n;
